import type { EventType, PayloadItems } from './types';

type TrackProperties = PayloadItems & Record<string, unknown>;

/**
 * Track an analytics event.
 *
 * Calls window.analytics?.track, this avoids errors when window.analytics is not loaded.
 * (when consent is not given or OneTrust fails to initialize).
 */
export const trackAnalytics = (
  event: (typeof EventType)[keyof typeof EventType],
  properties?: TrackProperties,
) => window.analytics?.track(event, properties);
